import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import Alert from 'components/base/Alert';
import Email from 'components/forms/Email';
import Toast from 'components/Toast';
import SMSCode from 'components/VerifyCodeSend';
import security from 'stores/security';
import { reportEventList } from 'utils/gtag';
import { setEmail } from 'utils/request';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Contact: React.FC<ProgressFormProps> = ({ $formutil }) => {
    const { $invalid, $batchState, $getFirstError, $params } = $formutil;
    const { email } = security.userInfo;
    const navigate = useNavigate();

    const onSubmit = async (ev: React.FormEvent) => {
        ev.preventDefault();

        if ($invalid) {
            $batchState({
                $dirty: true,
                $touched: true
            });

            Toast.show($getFirstError());
        } else {
            Toast.loading(true);

            reportEventList('contact');

            try {
                if (!email) {
                    await setEmail($params);

                    // 更新用户状态
                    await security.getStatus();
                }

                navigate('../revenue');
            } catch (error) {
                Toast.show(error);
            }

            Toast.loading(false);
        }
    };

    return (
        <form className="open-contact-root" noValidate onSubmit={onSubmit}>
            {email ? (
                <Alert variant="warning">
                    {__(
                        "Your contact information has already been added to your account. Please click 'Continue' to proceed to the next step"
                    )}
                </Alert>
            ) : (
                <div>
                    <h3 className="open-title">{__('EMAIL ADDRESS')}</h3>
                    <p>{__('In order to protect your account security, please add a valid email address')}</p>
                    <Email label={__('Email Address')} />
                    <SMSCode
                        type="email"
                        label={__('Verification Code')}
                        disabled={!!$formutil.$errors.email}
                        username={$formutil.$params.email}
                        process="bind_email"
                    />
                </div>
            )}
            <BackNextButtons />
        </form>
    );
};

export default withProgressForm({
    step: 4,
    id: 'contact',
    cache: false,
    basePath: 'esop'
})(observer(Contact));
